import React, { Component } from 'react';
import { Button, Modal, Message } from 'semantic-ui-react';

export default class Confirmation extends Component {
  constructor(props) {
    super(props);

    this.handleConfirmation = this.handleConfirmation.bind(this);
  }

  handleConfirmation() {
    this.props.onClose();

    // Pass customConfirmationHandler to replace the default handleConfirmation function
    if (
      Object.prototype.hasOwnProperty.call(
        this.props,
        'customConfirmationHandler',
      )
    ) {
      return this.props.customConfirmationHandler();
    }

    this.defaultConfirmationHandler();
  }

  defaultConfirmationHandler() {
    const csrfToken = document.head.querySelector('meta[name="csrf-token"]');
    const headers = {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    };

    // Needs to be checked because in test environment there's no crsf-token meta tag
    if (csrfToken) {
      headers['X-CSRF-Token'] = csrfToken.content;
    }

    fetch(this.props.path, {
      method: this.props.method,
      body: JSON.stringify(this.props.body),
      headers: headers,
    })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        Turbolinks.visit(this.props.newURL || response.url);
      })
      // eslint-disable-next-line no-console
      .catch((error) => console.log(error));
  }

  render() {
    return (
      <Modal
        className='action-confirmation'
        open={this.props.show}
        size={this.props.size}
        onClick={(e) => e.stopPropagation()} // https://github.com/Semantic-Org/Semantic-UI-React/issues/3174
        onClose={this.props.onClose}
      >
        <Modal.Header>{this.props.title}</Modal.Header>
        <Modal.Content>
          <If condition={typeof this.props.tip !== 'undefined'}>
            <Message
              warning
              size='tiny'
            >
              <p>
                <strong>TIP: </strong>
                {this.props.tip}
              </p>
            </Message>
          </If>
          <p>{this.props.msg}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button
            color='red'
            content='No'
            onClick={this.props.onClose}
          />
          <Button
            color='green'
            content='Yes'
            onClick={this.handleConfirmation}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

Confirmation.defaultProps = {
  size: 'small',
  msg: 'Are you sure you want to proceed?',
  body: {},
};
